<template>
  <div class="inner">
      <h2 class="fz-20 d-flex border-bottom mt-0">{{ $t('在庫情報') }}</h2>
        <div class="d-flex justify-content-start mt-4 mb-4">
          <button
            type="button"
            class="btn btn-success create-btn"
            @click="inventoryKindLink()"
          >
            {{ $t('在庫区分情報登録') }}
          </button>
        </div>
        <div
        id="inventoryInfoDrawing-parent">
          <div class="card">
            <div class="accordion card-header d-flex justify-content-between" id="inventoryInfoDrawing-header" data-toggle="collapse" data-target="#inventoryInfoDrawing" :aria-expanded="false" aria-controls="inventoryInfoDrawing">
              <h3 class="mb-0">{{ $t('保管場所') }}</h3>
              <div class="accordion-toggle-btn">
                <b-button block id="inventoryInfoDrawing-up">{{ $t('閉じる') }}</b-button>
                <b-button block id="inventoryInfoDrawing-down">{{ $t('開く') }}</b-button>
              </div>
            </div>
            <div id="inventoryInfoDrawing" class="collapse" aria-labelledby="inventoryInfoDrawing-header" data-parent="#inventoryInfoDrawing-parent">
              <div class="card-body">
                <table v-for="(item, index) in inventories" :key="index" class="table border-0 table-bordered">
                  <thead class="thead border-0">
                    <tr class="border-0">
                      <th class="border-0 text-left">{{ $t('在庫情報') }}{{ index + 1 }}</th>
                    </tr>
                  </thead>
                  <tbody class="tbody">
                    <tr>
                      <th class="table-active text-left w-15">{{ $t('在庫区分') }}</th>
                      <td class="w-20">
                        <template v-if="mixinIdKeyDisplay('inventoryKinds',item.inventoryKindId,'name')">
                          {{ mixinIdKeyDisplay('inventoryKinds',item.inventoryKindId,'name') }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left w-15">{{ $t('工場') }}</th>
                      <td class="w-20">
                        <template v-if="mixinIdKeyDisplay('spaces',item.site,'name')">
                          {{ mixinIdKeyDisplay('spaces',item.site,'name') }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left w-15">{{ $t('部署') }}</th>
                      <td class="w-15">
                        <template v-if="mixinIdKeyDisplay('spaces',item.dep,'name')">
                          {{ mixinIdKeyDisplay('spaces',item.dep,'name') }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th class="table-active text-left w-15">{{ $t('置き場') }}</th>
                      <td class="text-break w-20">
                        <template v-if="mixinArrayKeyDisplay('spaces',item.place,'name')">
                          {{ mixinArrayKeyDisplay('spaces',item.place,'name') }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left w-15">{{ $t('棚番') }}</th>
                      <td class="text-break w-20">
                        <template v-if="mixinArrayKeyDisplay('spaces',item.box,'name')">
                          {{ mixinArrayKeyDisplay('spaces',item.box,'name') }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left w-15">{{ $t('保管期間') }}</th>
                      <td class="w-15">
                        <template v-if="!isEmpty(item.period)">
                          {{ item.period }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th class="table-active text-left w-15">{{ $t('標準在庫数') }}</th>
                      <td class="w-20">
                        <template v-if="!isEmpty(item.baseQuantity)">
                          {{ item.baseQuantity }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left w-15">{{ $t('補充ロットサイズ') }}</th>
                      <td class="w-20">
                        <template v-if="!isEmpty(item.supplyLotSize)">
                          {{ item.supplyLotSize }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left w-15">{{ $t('補充リードタイム') }}</th>
                      <td class="w-15">
                        <template v-if="!isEmpty(item.supplyLeadTime)">
                          {{ item.supplyLeadTime }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th class="table-active text-left w-15">{{ $t('保管場所備考') }}</th>
                      <td colspan="5" class="text-break">
                        <template v-if="!isEmpty(item.note)">
                          {{ item.note }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3 mb-5">
          <button
            type="button"
            class="btn btn-light create-btn"
            @click="storageModalOpen()"
          >
            {{ $t('編集') }}
          </button>
          <!-- <button
            type="button"
            class="btn btn-danger create-btn"
          >
            {{ $t('保管場所削除') }}
          </button> -->
        </div>
        <storage-modal
        ref="storage"
        :productId="productId"
        :inventories="inventories"
        :inventoryKinds="inventoryKinds"
        :spaces="spaces"
        @registered="registered()"
        @modalClose="modalClose()"
        ></storage-modal>
  </div>
</template>

<script>
import storageModal from './storageModal'
export default {
  props: {
    productId: {
      type: Number,
      required: true,
      default: 0,
    },
    inventories: {
      type: Array,
      required: true,
      default: () => [],
    },
    inventoryKinds: {
      type: Array,
      required: true,
      default: () => [],
    },
    spaces: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    storageModal,
  },
  mounted() {
    const up = document.getElementById('inventoryInfoDrawing-up')
    const down = document.getElementById('inventoryInfoDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')
    $('#inventoryInfoDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('inventoryInfoDrawing-up')
      const down = document.getElementById('inventoryInfoDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#inventoryInfoDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('inventoryInfoDrawing-up')
      const down = document.getElementById('inventoryInfoDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
  },
  methods: {
    storageModalOpen() {
      this.$refs.storage.modalOpen()
    },
    inventoryKindLink() {
      window.location.href = process.env.NODE_ENV !== 'development' ? '/base/inventory-kind/index.html' : '/inventory-kind/index.html'
    },
    registered() {
      this.$emit('registered')
    },
    modalClose() {
      this.$emit('modalClose')
    },
  },
  watch: {
    'inventories': {
      handler: function(newVal) {
        if (newVal.length === 0) {
          $('#inventoryInfoDrawing').collapse('hide')
        } else {
          $('#inventoryInfoDrawing').collapse('show')
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
.table > .thead tr th {
  font-size: 1.6rem;
}
</style>
